var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-geo",
    width: 18.879,
    height: 26.943,
    viewBox: "0 0 18.879 26.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_geo",
    d: "M267.574,641.209c-1.713-3.1-5.339-3.612-8.18-3.457a6.459,6.459,0,0,1-.7,0c-2.832-.155-6.333.353-8.045,3.457-1.146,2.1-1.189,6.6-.614,8.7.656,2.387,4.171,7.77,5.2,10.27,0,0,2.525,4.573,3.727,4.493a3.267,3.267,0,0,1,.332,0c1.2.042,3.7-4.495,3.7-4.495,1.049-2.394,4.539-7.883,5.2-10.27C268.763,647.812,268.72,643.309,267.574,641.209Zm-8.65,9.875c-1.628,0-3.954-2.047-3.861-3.907a5.056,5.056,0,0,1,3.629-3.819,4.731,4.731,0,0,1,3.4,1.225,6.286,6.286,0,0,1,1.064,2.827C263.3,649.13,260.506,651.131,258.925,651.084Z",
    transform: "translate(-249.672 -637.727)",
    fill: "#ec671d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGeo);
export default __webpack_public_path__ + "static/media/ic_geo.66bcdeb32a73a1fca9ddc2deb5a5227c.svg";
export { ForwardRef as ReactComponent };